export class ImageManager {
  private baseUrl: string; // Optional: Base URL for relative paths

  constructor(baseUrl?: string) {
    this.baseUrl = baseUrl || ''; // Set default or provided base URL
  }

  async downloadImage(imageUrl: string): Promise<Blob> {
      
      
    const url = this.resolveUrl(imageUrl); // Handle relative paths if baseUrl is set
    const response = await fetch(url);
    if (response.ok) {
      return await response.blob();
    } else {
      throw new Error(`Failed to download image: ${imageUrl}`);
    }
  }

  private resolveUrl(imageUrl: string): string {
    if (this.baseUrl && imageUrl.startsWith('/')) {
      return this.baseUrl + imageUrl;
    } else {
      return imageUrl; // Absolute URL or relative to current location
    }
  }

  async convertBlobToBase64(blob: Blob): Promise<string> {
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
      fileReader.onload = (event) => {
        const base64Data = event.target.result as string; // Base64-encoded data
        resolve(base64Data);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
      fileReader.readAsDataURL(blob); // Convert to Data URL (Base64 encoded)
    });
  }

  async downloadAndConvertImageToBase64(imageUrl: string): Promise<string> {
      
      
    const blob = await this.downloadImage(imageUrl);
    const base64Data = await this.convertBlobToBase64(blob);
    return base64Data;
  }
}